export function slider( node, config = {} ) {
	config = {
		wrap: '.slider__wrap',
		next: '.slider__next',
		prev: '.slider__prev',
		// we'll use wrap.children instead of post-slider__wrap .card/.excerpt
		items: '.slider__item',
		...config
	};

	const wrap  = node.querySelector( config.wrap );
	const items = [ ...wrap.children];
	const next  = node.querySelector( config.next );
	const prev  = node.querySelector( config.prev );

	if ( ! wrap || ! items ) {
		return;
	}

	let interval = null;

	const getCurrentScrollIndex = () => {
		return items.map( item => Math.abs( item.offsetLeft - wrap.scrollLeft ) ).reduce( ( closest, left, i, lefts ) => {
			return left < lefts[ closest ] ? i : closest;
		}, items.length - 1 );
	};

	const setScrollIndex = ( index, behavior = 'smooth' ) => {
		const viewable = getComputedStyle(wrap).getPropertyValue('--viewable');

		if ( index <= items.length - viewable ) {
			wrap.scrollTo( {
				left: items[ index ].offsetLeft,
				top: 0,
				behavior
			} );
		} else if ( interval > 0 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const setState = () => {
		if (!items.length || !wrap) {
			return;
		}

		const firstItemInView = items[0].offsetLeft >= wrap.scrollLeft;
		const lastItemInView =
			items[items.length - 1].offsetLeft <=
			wrap.scrollLeft + wrap.offsetWidth - items[items.length - 1].offsetWidth;

		// Handle "next" button state
		if (lastItemInView) {
			// next.disabled = true;
			next.classList.add('is-disabled');
		} else {
			// next.disabled = false;
			next.classList.remove('is-disabled');
		}

		// Handle "prev" button state
		if (firstItemInView) {
			// prev.disabled = true;
			prev.classList.add('is-disabled');
		} else {
			// prev.disabled = false;
			prev.classList.remove('is-disabled');
		}
	};

	const scrollPrev = () => {
		const index = Math.round( Math.max( getCurrentScrollIndex() - 1, 0 ) );
		setScrollIndex( index );

		if ( interval && index <= 0 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const scrollNext = () => {
		const index = Math.round( Math.min( getCurrentScrollIndex() + 1, items.length - 1 ) );
		setScrollIndex( index );

		if ( interval !== null && index === items.length - 1 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const mouseout = function() {
		this.removeEventListener( 'mouseout', mouseout );
	}

	const mousedown = function( cb, delay = 200 ) {
		if ( null !== interval ) {
			clearInterval( interval );
		}

		interval = setInterval( cb, delay );
		this.addEventListener( 'mouseup', mouseup );
		this.addEventListener( 'mouseout', mouseout );
	}

	const mouseup = function() {
		this.removeEventListener( 'mouseup', mouseup );
		window.clearInterval( interval );
		interval = null;
	}

	if ( prev ) {
		prev.addEventListener( 'mousedown', () => mousedown.call( prev, scrollPrev ) );
		prev.addEventListener( 'click', scrollPrev );
	}

	if ( next ) {
		next.addEventListener( 'mousedown', () => mousedown.call( next, scrollNext ) );
		next.addEventListener( 'click', scrollNext );
	}

	wrap.addEventListener( 'scroll', setState );
	window.addEventListener( 'resize', () => {
		setScrollIndex( getCurrentScrollIndex() );
		setState();

		if ( typeof config.resize === 'function' ) {
			config.resize();
		}
	} );
	setScrollIndex( 0 );
	setState();

	return node;
}
